"use client";

import { Button } from "@heroui/button";
import {
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from "@heroui/modal";

import type { LanguageCode } from "@/config/i18n";
import { createTranslator } from "@/lib/i18n/translations";

import { BOTTOM_SHEET } from "./RatingDialog";

export interface ConfirmUnwatchDialogProps {
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  lang: LanguageCode;
  movieTitle: string;
  rating: number;
  onConfirm: () => void;
}

/** Un-marking a rated movie also deletes its rating: ask first. */
export function ConfirmUnwatchDialog({
  isOpen,
  onOpenChange,
  lang,
  movieTitle,
  rating,
  onConfirm,
}: ConfirmUnwatchDialogProps) {
  const t = createTranslator(lang);

  return (
    <Modal
      classNames={BOTTOM_SHEET}
      isOpen={isOpen}
      placement="auto"
      size="sm"
      onOpenChange={onOpenChange}
    >
      <ModalContent>
        {(onClose) => (
          <>
            <ModalHeader>{t("library.confirmUnwatch.title")}</ModalHeader>
            <ModalBody>
              <p>
                {t("library.confirmUnwatch.body", {
                  rating,
                  title: movieTitle,
                })}
              </p>
            </ModalBody>
            {/* Phones: full-width buttons, the action on top. */}
            <ModalFooter className="flex-col-reverse sm:flex-row">
              {/* The safe choice gets focus first. */}
              <Button
                autoFocus
                className="h-11 w-full sm:h-10 sm:w-auto"
                variant="light"
                onPress={onClose}
              >
                {t("library.confirmUnwatch.cancel")}
              </Button>
              <Button
                className="h-11 w-full sm:h-10 sm:w-auto"
                color="danger"
                onPress={() => {
                  onConfirm();
                  onClose();
                }}
              >
                {t("library.confirmUnwatch.confirm")}
              </Button>
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  );
}
